import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import Swal from 'sweetalert2';
import { MunicipioServices } from '../../../core/services/municipio.service';

@Component({
  selector: 'app-nuevo-municipio-dialog',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDialogActions,
    MatDialogContent,
  ],
  templateUrl: './nuevo-municipio-dialog.html',
  styleUrl: './nuevo-municipio-dialog.scss',
})
export class NuevoMunicipioDialog implements OnInit {
  private fb = inject(FormBuilder);

  guardando = false;

  constructor(
    private dialogRef: MatDialogRef<NuevoMunicipioDialog>,
    private municipioService: MunicipioServices,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  form = this.fb.group({
    nombre: ['', Validators.required],
    acronimo: ['', [Validators.required, Validators.maxLength(10)]],
  });

  get municipio(): any {
    return this.data?.municipio;
  }

  get esEdicion(): boolean {
    return !!this.municipio?.id;
  }

  ngOnInit(): void {
    if (this.municipio) {
      this.form.patchValue({
        nombre: this.municipio.nombre ?? '',
        acronimo: this.municipio.acronimo ?? '',
      });
    }
  }

  cerrar(): void {
    this.dialogRef.close();
  }

  guardar(): void {
    if (this.guardando) return;

    const valores = this.form.getRawValue();
    const payload = {
      nombre: (valores.nombre ?? '').trim(),
      acronimo: (valores.acronimo ?? '').trim().toUpperCase(),
    };

    if (this.form.invalid || !payload.nombre || !payload.acronimo) {
      this.form.markAllAsTouched();
      return;
    }

    this.guardando = true;

    const peticion = this.esEdicion
      ? this.municipioService.actualizarMunicipio(this.municipio.id, payload)
      : this.municipioService.crearMunicipio(payload);

    peticion.subscribe({
      next: (respuesta) => {
        Swal.fire({
          icon: 'success',
          title: this.esEdicion ? 'Municipio actualizado' : 'Municipio agregado',
          showConfirmButton: false,
          timer: 2000,
        }).then(() => this.dialogRef.close(respuesta?.data ?? respuesta));
      },
      error: (error) => {
        this.guardando = false;

        Swal.fire({
          icon: 'error',
          title: 'No se pudo guardar',
          text:
            error?.error?.message?.join?.(', ') ??
            error?.error?.message ??
            'Ocurrió un error al guardar el municipio.',
          showConfirmButton: false,
          timer: 2000,
        });
      },
    });
  }
}
